module.exports = __webpack_public_path__ + "img/ProfilePicture.091301e1.png";